import { z } from "zod";
import { LOT_STATUSES, TRANSPORT_KINDS } from "./enums";

/** Форма создания/редактирования лота (раздел 4 требований). */
export const lotInputSchema = z.object({
  projectId: z.string().uuid(),
  transportKind: z.enum(TRANSPORT_KINDS),
  loadingAddress: z.string().min(3),
  loadingAt: z.coerce.date(),
  intermediateAddresses: z.array(z.string().min(1)).default([]),
  unloadingAddress: z.string().min(3),
  vehicleTypeId: z.string().uuid(),
  weightKg: z.number().int().positive(),
  lengthM: z.number().positive(),
  widthM: z.number().positive(),
  heightM: z.number().positive(),
  placesCount: z.number().int().positive().nullable().default(null),
  cargoName: z.string().min(1),
  cargoDescription: z.string().default(""),
  specialConditions: z.string().default(""),
  insurance: z.string().default(""),
  contactUserId: z.string().uuid().nullable().default(null),
  deadlineAt: z.coerce.date(),
  autoExtend: z.boolean().default(false),
});
export type LotInput = z.infer<typeof lotInputSchema>;

/** Карточка лота в списке портала. Авторы ставок сюда никогда не попадают. */
export const lotListItemSchema = z.object({
  id: z.string().uuid(),
  number: z.string(),
  status: z.enum(LOT_STATUSES),
  projectName: z.string(),
  transportKind: z.enum(TRANSPORT_KINDS),
  loadingAddress: z.string(),
  unloadingAddress: z.string(),
  loadingAt: z.string(),
  vehicleTypeName: z.string(),
  weightKg: z.number(),
  deadlineAt: z.string(),
  autoExtend: z.boolean(),
  autoExtensionsUsed: z.number(),
  currentMinAmount: z.number().nullable(),
  bidsCount: z.number(),
  createdByName: z.string(),
});
export type LotListItem = z.infer<typeof lotListItemSchema>;

export const extendLotSchema = z.object({
  deadlineAt: z.coerce.date(),
  reason: z.string().min(1),
});

export const cancelLotSchema = z.object({
  reason: z.string().min(1),
});
